import axios from 'axios';

const API_BASE_URL = (process.env.REACT_APP_API_URL || 'http://localhost:4001') + '/api/v1';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

// Request interceptor for debugging
api.interceptors.request.use(
  (config) => {
    console.log('API Request:', config);
    return config;
  },
  (error) => {
    console.error('API Request Error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => {
    console.log('API Response:', response);
    return response;
  },
  (error) => {
    console.error('API Response Error:', error);
    return Promise.reject(error);
  }
);

export const candidateAPI = {
  register: async (formData) => {
    try {
      const response = await api.post('/candidates/register-candidate', formData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  
  getSubjects: async () => {
    try {
      const response = await api.get('/candidates/subjects', {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  resendRegistrationEmail: async (email) => {
    try {
      const response = await api.post('/candidates/resend-email', { email }, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  bulkRegister: async (file) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      const response = await api.post('/candidates/bulk-register', formData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

export default api;